import React from 'react';
import {Col, Container, Image, Row} from "react-bootstrap";
import TopImageCard from "../accesories/card/TopImageCard";
import './ourBlog.css'

function OurBlog({blogs}) {

    const today = new Date();
    const month = today.getMonth() + 1;
    const day = today.getDate();
    const sum = month + day;

    return (
        <Container className={'our-blog-container'}>
            <Row className={'our-blog-up-row text-center mb-4'}>
                <h3><span>بلاگ</span> داپا</h3>
                <div className={'horizontal-line'}/>
            </Row>
            <Row className={'our-blog-down-row'}>
                {blogs.map(blog => (
                    <TopImageCard key={blog.id} href={`/blogs/${blog.id}`} img={blog.thumbnail} title={blog.title}
                                  category={blog.category} view={sum + (2 * blog.id)}/>
                ))
                }

            </Row>
        </Container>
    );
}

export default OurBlog;